import Link from 'gatsby-link';
import * as React from 'react';
import styled from 'styled-components';
import IImage from '../../Entities/Image';
import ILink from '../../Entities/Link';
import Image from '../Image/Image';

const Contact = styled.a`
  color: #555;
`;

const Footer = styled.footer`
  background: #eee;
  padding-top: 3rem;
  padding-bottom: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export interface Props {
  image?: IImage;
  links?: ILink[];
}

export default class extends React.PureComponent<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
      <Footer {...this.state}>
        <Link to={'/'}>{this.props.image && <Image {...this.props.image} maxWidth="250px" />}</Link>
        <Contact href="mailto:info@elesthorp.se">info@elesthorp.se</Contact>
      </Footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx